<template>
  <footer>
    <img src="./assets/footer.png" alt="Footer" class="mx-auto" />
    <div class="footer-container">
      <div class="footer-top">
        <div class="grid grid-cols-2 gap-4">
          <div class="flex items-end">
            <div class="grid grid-cols-1 gap-4">
              <p class="text-base text-xs">
                &copy; Heineken UK Limited 2025,<br />Heineken UK Limited<br />
                Registered Company No. SC065527<br />
                Registered Office 6 St Andrew Square, Edinburgh, EH2 2BD
              </p>

              <a href="https://www.drinkaware.co.uk/" target="_blank">
                <img src="./assets/drink-aware.svg" />
              </a>
              <a href="https://www.fosters.co.uk/alcohol-and-health-information" target="_blank">
                <img src="./assets/drink-responsibly.svg" />
              </a>
              <img src="./assets/brewed-uk.svg" />
            </div>
          </div>
          <div class="flex justify-end items-start">
            <img src="./assets/footerLogo.png" alt="Footer" class="max-h-fit footer-logo" />
          </div>
        </div>
      </div>
      <div class="max-w-800 m-auto">
        <div class="footer-links">
          <ul>
            <li><a href="https://www.fosters.co.uk" target="_blank">Foster's Home</a></li>
            <li><a href="/goodcalldartsclub/terms-conditions">Terms &amp; Conditions</a></li>
            <li>
              <a href="https://www.fosters.co.uk/terms-of-use" target="_blank">Terms of Use</a>
            </li>
            <li>
              <a
                href="https://www.heineken.co.uk/legal-hub/heineken-brands-privacy-policy"
                target="_blank"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a href="https://www.fosters.co.uk/cookie-policy" target="_blank">Cookie Policy</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
